import { useMemo } from 'react';
import { v4 } from 'uuid';

export function useUniqueIdForThisMount(): string {
    return useMemo(() => v4(), []);
}
